var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#2c3e50",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2511 4521 c-49 -17 -91 -56 -508 -472 -250 -250 -462 -468 -473 -484 -72 -115 -31 -272 87 -342 63 -37 166 -39 228 -6 22 12 141 123 265 247 124 124 228 226 232 226 5 0 8 -430 8 -955 0 -835 2 -960 15 -992 40 -96 124 -154 223 -154 99 -1 177 47 225 136 l22 40 3 964 2 965 238 -236 c205 -204 244 -237 286 -252 61 -20 98 -20 163 -1 93 28 162 122 163 220 0 111 16 91 -483 595 -254 256 -480 475 -502 488 -58 32 -128 37 -194 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 2173 c-62 -32 -113 -93 -130 -155 -7 -28 -9 -165 -7 -432 5 -441 5 -442 85 -606 39 -80 59 -108 137 -186 77 -76 106 -98 186 -137 181 -89 28 -81 1685 -85 988 -2 1496 1 1550 8 266 35 472 184 586 426 66 140 69 161 69 609 0 445 0 444 -70 513 -44 44 -82 63 -144 69 -106 11 -196 -39 -243 -135 l-28 -57 -5 -385 c-4 -339 -7 -389 -22 -416 -24 -44 -73 -91 -122 -117 l-41 -22 -1455 -3 c-1646 -3 -1514 -9 -1601 78 -76 76 -79 93 -79 509 0 336 -2 358 -21 401 -60 132 -205 186 -330 123z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/Submit.e99a5ac07ec40d70fed14deda35a79dd.svg";
export { ForwardRef as ReactComponent };